import { Company } from "./Company";

export default class AmlData {
  companies: Company[] = [];
  oldCompanies: Company[] = [];
  updatedCompanies: Company[] = [];
}
